.welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-2xl);
}

.intro {
  margin: 0;
  max-width: 520px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.roll {
  width: 100%;
  max-width: 520px;
}

.modes {
  align-items: flex-start;
  text-align: left;
}

.notice {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  font-weight: 700;
}

.problem {
  margin: 0;
  max-width: 520px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-feedback-warning-text);
}

.headphones {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--tuna-spacing-1);
  max-width: 520px;
  text-align: left;
}

.headphonesWhy {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}

.privacy {
  margin: 0;
  max-width: 520px;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.device {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}

.levels {
  align-items: flex-start;
  text-align: left;
}
